import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// project import
import defaultConfig from "config";

// types
import {
  FontFamily,
  I18n,
  MenuOrientation,
  PresetColor,
  ThemeDirection,
  ThemeMode,
} from "shared/types/config";


const config = createSlice({
    name:"config",
    initialState: defaultConfig,
    reducers:{
        onChangeMenuOrientation(state, action: PayloadAction<MenuOrientation>){
            state.menuOrientation = action.payload;
        },
        onChangeMiniDrawer(state, action: PayloadAction<boolean>){
            state.miniDrawer = action.payload;
        },
        onChangeMode(state, action: PayloadAction<ThemeMode>){
            state.mode = action.payload;
        },
        onChangePresetColor(state, action: PayloadAction<PresetColor>){
            state.presetColor = action.payload;
        },
        onChangeLocale(state, action: PayloadAction<I18n>){
            state.i18n = action.payload;
        },
        onChangeDirection(state, action: PayloadAction<ThemeDirection>){
            state.themeDirection = action.payload;
        },
        onChangeContainer(state, action: PayloadAction<boolean>){
            state.container = action.payload;
        },
        onChangeFontFamily(state, action: PayloadAction<FontFamily>){
            state.fontFamily = action.payload;
        },
        onChangeBorderRadius(state, action: PayloadAction<number|number[]>){
            state.borderRadius = action.payload as number;
        },
        onChangeOutlinedField(state, action: PayloadAction<boolean>){
            state.outlinedFilled = action.payload;
        },
        onReset(state){
            state = defaultConfig;
        },
    }

})
export default config.reducer;
export const {
    onChangeMenuOrientation, 
    onChangeMiniDrawer, 
    onChangeMode,
    onChangePresetColor,
    onChangeLocale,
    onChangeDirection,
    onChangeContainer,
    onChangeFontFamily,
    onChangeBorderRadius,
    onChangeOutlinedField,
    onReset
} = config.actions